import { DebounceSearchInput } from '@checkit/react-components';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

type InputChangeHandler = (value: string | null) => void;

interface Props {
  onValueChange: InputChangeHandler;
  initialValue: string;
}

const messages = defineMessages({
  'libraries.search.filterPlaceholder': {
    defaultMessage: 'Filter by name or description',
    id: 'libraries.search.filterPlaceholder'
  }
});

const LibraryFilter: FC<Props> = (props: Props) => {
  const { initialValue, onValueChange } = props;
  const { formatMessage } = useIntl();

  const onInputChange = (term: string | null) => {
    onValueChange(term);
  };

  return (
    <DebounceSearchInput
      defaultValue={initialValue}
      fullWidth={true}
      id={'libraryFilter'}
      name={'libraryFilter'}
      placeholder={formatMessage(messages['libraries.search.filterPlaceholder'])}
      onSearchTermChanged={onInputChange}
    />
  );
};

export default LibraryFilter;
